/** Decimal places used when a score is shown in the grouped and detailed views. */
const SCORE_PRECISION = 3;

/**
 * Renders a score as x.xxx for display only.
 *
 * This is passed as a column `formatter`, which PredictionsTableRow applies when
 * painting a readonly cell — it never writes back to tableData. Saving reads the
 * movies straight off the prediction store and CSV export reads raw row values,
 * so both keep the full-precision numbers the API returned.
 *
 * Anything non-numeric is returned untouched, so blank cells stay blank rather
 * than rendering NaN.
 */
export const formatScore = (value: any): string => {
  if (value === null || value === undefined || value === '') return '';

  const numeric = typeof value === 'number' ? value : Number(value);

  return Number.isFinite(numeric)
    ? numeric.toFixed(SCORE_PRECISION)
    : String(value);
};
